@if (userForm) {
  <layout>
    <top-bar>
      <sub-navigation>
        <sub-navigation-item path="/my-account" icon="person">
          {{ 'TAB.MYACCOUNT' | translate }}
        </sub-navigation-item>
      </sub-navigation>
    </top-bar>
    <left-panel [isExpanded]="true" verticalHeight="fill">
      <container [isScrollable]="true" verticalHeight="fill" padding="large">
        <div class="button-container">
          <button matButton="filled" class="secondary" (click)="resetApp()">
            <mat-icon>refresh</mat-icon>
            {{ 'USER.RESET_SESSION' | translate }}
          </button>

          <button matButton="filled" class="alert" (click)="logout()">
            <mat-icon>logout</mat-icon>
            {{ 'CONNECTION.LOGOUT' | translate }}
          </button>
        </div>
        <div class="cards">
          <!------------------------ PROFIL ------------------------------>
          <div class="card" style="grid-column: span 1">
            <ubi-title [level]="2">
              {{ 'PARAM.PROFILE' | translate }}
            </ubi-title>

            <form [formGroup]="userForm" style="width: 100%">
              <!-- FIRSTNAME -->
              <mat-form-field appearance="outline" color="accent">
                <mat-label>{{ 'COMMON.FIRSTNAME' | translate }}</mat-label>
                <input matInput type="text" formControlName="firstname" />
                <mat-hint align="end">{{ userForm.value.firstname.length || 0 }}/50</mat-hint>
              </mat-form-field>

              <!-- LASTNAME -->
              <mat-form-field appearance="outline" color="accent">
                <mat-label>{{ 'COMMON.NAME' | translate }}</mat-label>
                <input matInput type="text" formControlName="lastname" />
                <mat-hint align="end">{{ userForm.value.lastname.length }}/50</mat-hint>
              </mat-form-field>

              <!-- MAIL -->
              <mat-form-field appearance="outline" color="accent">
                <mat-label>{{ 'COMMON.MAIL' | translate }}</mat-label>
                <input matInput type="mail" formControlName="mail" />
                <mat-hint align="end">{{ userForm.value.mail.length || 0 }}/255</mat-hint>
              </mat-form-field>

              <!-- PHONE -->
              <phone-input formControlName="phone" />
            </form>

            <!-- PASSWORD -->
            <div class="password">
              <mat-form-field appearance="outline" color="accent">
                <mat-label>{{ 'CONNECTION.PASSWORD' | translate }}</mat-label>
                <input matInput type="password" disabled value="************" />
              </mat-form-field>
              <button
                matButton="outlined"
                color="primary"
                class="stretch"
                (click)="goToChangePassword()"
                [disabled]="!myAccount">
                {{ 'USER.EDIT_MY_PASSWORD' | translate }}
              </button>
            </div>
          </div>

          <!------------------------ CONFIGURATION ----------------------->
          <div class="card" style="grid-column: span 1">
            <ubi-title [level]="2">
              {{ 'PARAM.CONFIGURATION' | translate }}
            </ubi-title>
            <form [formGroup]="userParamsForm">
              <!-- LANGUAGE -->
              <mat-form-field appearance="outline" color="accent">
                <mat-label>{{ 'PARAM.LANG' | translate }}</mat-label>
                <mat-select formControlName="language">
                  <mat-option value="fr">FR</mat-option>
                  <mat-option value="en">EN</mat-option>
                </mat-select>
              </mat-form-field>

              <!-- SPEEDUNIT -->
              <mat-form-field appearance="outline" color="accent">
                <mat-label>{{ 'PARAM.SPEEDUNIT' | translate }}</mat-label>
                <mat-select formControlName="speedUnit">
                  <mat-option value="speed">{{ 'UNITS.SPEED' | translate }}</mat-option>
                  <mat-option value="speedBoat">kn ({{ 'PARAM.KNOTS' | translate }})</mat-option>
                </mat-select>
              </mat-form-field>

              <!-- DEVICEVIEW -->
              <mat-form-field appearance="outline" color="accent">
                <mat-label>{{ 'PARAM.DEVICE_VIEW' | translate }}</mat-label>
                <mat-select formControlName="deviceView">
                  <mat-option value="registration">{{ 'PARAM.REGISTRATION' | translate }}</mat-option>
                  <mat-option value="summary">{{ 'PARAM.SUMMARY' | translate }}</mat-option>
                  <mat-option value="snexternal">{{ 'PARAM.SNEXTERNAL' | translate }}</mat-option>
                </mat-select>
              </mat-form-field>
            </form>
          </div>
        </div>

        <div class="button-container">
          <button
            matButton="filled"
            color="accent"
            type="submit"
            [disabled]="
              (userForm.invalid || userForm.pristine) && (userParamsForm.invalid || userParamsForm.pristine)
            "
            (keyup.enter)="updateMyAccount()"
            (click)="updateMyAccount()">
            {{ 'COMMON.SAVE' | translate }}
          </button>
        </div>
      </container>
    </left-panel>
  </layout>
}
